var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFullScreen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 40.03",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5V45H50V5ZM17.61,35.25v2.93H6.84V27.4H9.76v5.78l9.08-9.07,2.07,2.07-9.07,9.07ZM43.15,22.6H40.23V16.82l-9.07,9.07-2.07-2.07,9.07-9.07H32.38V11.82H43.15Z",
    transform: "translate(0 -4.98)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFullScreen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-full-screen.2f9c6002.svg";
export { ForwardRef as ReactComponent };